import React from "react";

import { useSelector } from "react-redux";
import { views } from "../utils";

/*const airlines = [
  { label: "Lufthansa", value: "LH" },
  { label: "Air France", value: "AF" },
  { label: "Easyjet", value: "U2" },
  { label: "Eurowings", value: "EW" },
];*/

export default function AirlineFilter(props) {
  const { changeFilterAndSearch } = props;
  const [showAll, setShowAll] = React.useState(false);
  const view = useSelector((state) => state.system.view);
  const loading = useSelector((state) => state.system.loading);
  const airlines = useSelector((state) => state.properties.airlines);
  const transportOperators = useSelector(
    (state) => state.filter.transportOperators
  );
  const operatingbrand = useSelector((state) => state.search.operatingbrand);

  let ct = 0;

  return (
    <div className="touroperatorsfilter">
      <span className="touroperatorsfilter1  filterheader">
        Fluggesellschaft
      </span>
      <br />

      {[...airlines]
        .sort((a, b) => a.label.localeCompare(b.label))
        .map((itm, kidx) => {
          if (
            !(
              transportOperators.map((e) => e.value).includes(itm.value) ||
              operatingbrand.includes(itm.value)
            )
          )
            return <React.Fragment key={kidx}></React.Fragment>;

          ct = ct + 1;

          if (ct > 5 && !showAll) return null;

          return (
            <React.Fragment key={kidx}>
              <div className="filterrow" key={itm.value}>
                <div className="filter1">
                  <input
                    className="boardtypefilter4"
                    checked={operatingbrand.includes(itm.value)}
                    onChange={() => {
                      let changed = [...operatingbrand];
                      if (changed.includes(itm.value)) {
                        changed = changed.filter((e) => e !== itm.value);
                      } else {
                        changed.push(itm.value);
                      }

                      changed = changed.filter((c) =>
                        transportOperators.map((to) => to.value).includes(c)
                      );

                      changeFilterAndSearch("operatingbrand", changed);
                    }}
                    type="checkbox"
                  />
                </div>
                <div className="filter2">
                  <div
                    className="filtertext"
                    dangerouslySetInnerHTML={{
                      __html: "" + itm.label,
                    }}
                  ></div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      {!showAll && ct > 5 && (
        <div style={{ cursor: "pointer" }} onClick={() => setShowAll(true)}>
          alle anzeigen
        </div>
      )}
      {showAll && (
        <div style={{ cursor: "pointer" }} onClick={() => setShowAll(false)}>
          weniger anzeigen
        </div>
      )}
    </div>
  );
}
